import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import iconIA from 'assets/images/icone-ia.svg';
import { SuggestionTypes } from 'store/modules/juridico_facil_store/types';

import { Container } from './styles';

interface Props {
  sugestoes: SuggestionTypes[];
}

const AiSuggestion: React.FC<Props> = ({ sugestoes }) => {
  if (!sugestoes?.length) return null;

  return (
    <Container>
      <div className="ai-wrapper">
        <div className="ai-header mb-4">
          <div className="ai-icon">
            <img
              alt="Icone Consultor Jurídico"
              src={iconIA}
              height="24px"
              aria-hidden="true"
              className="ml-1"
            />
          </div>
          <div className="align-items-center">
            <h3 className="ai-title">Sugestão da IA</h3>
            <p className="ai-subtitle m-0 p-0">
              Conteúdos relacionados ao tema que você está lendo
            </p>
          </div>
        </div>

        <div className="ai-grid">
          {sugestoes.slice(0, 3).map((item) => (
            <div key={item.id} className="ai-card">
              <div>
                <span className="ai-badge p-0 px-2">{item.subtema}</span>
                <div className="ai-card-date">{moment(item.data_sessao).format('DD/MM/YYYY')}</div>
                <h5 className="ai-card-title">{item.acordao}</h5>
                <p className="ai-card-description">{item.enunciado}</p>
              </div>

              <div className="d-flex align-items-center">
                <Link to={`/juridico/show/${item.id}`} className="ai-link">
                  Ler conteúdo
                  <span className="material-icons">arrow_forward</span>
                </Link>
              </div>
            </div>
          ))}
        </div>

        <hr className="divisor mt-4 mb-4" />

        <div className="ai-footer">
          As sugestões são geradas por inteligência artificial com base no conteúdo que você está
          visualizando
        </div>
      </div>
    </Container>
  );
};

export default AiSuggestion;
